import type { ComponentProps } from 'react'
import { useSelector } from 'react-redux'

import { getFilters as getOnHandFilters } from '~/store/duck/onHandCatalog'

import SubcategoryFilter from '../filters/SubcategoryFilter'

const OnHandSubcategoryFilter = (
  props: ComponentProps<typeof SubcategoryFilter>,
) => {
  const onHandFilters = useSelector(getOnHandFilters)

  return (
    <SubcategoryFilter
      selectedCategoryFilter={onHandFilters?.categoryIds}
      selectedSubcategoryFilter={onHandFilters?.subcategoryIds}
      {...props}
    />
  )
}

export default OnHandSubcategoryFilter
